import { TextProps } from '@mantine/core';
import { Text } from '@zorro/web/design-system';
import { getCarrierLogoUrl } from '@zorro/web/ui-utils';
import Image from 'next/image';
import { useState } from 'react';

type CarrierLogoNextProps = Partial<React.ComponentProps<typeof Image>> & {
  plan: {
    logoUrl?: string | undefined;
    carrierName: string;
  };
  fw?: number;
  style?: React.CSSProperties;
  textProps?: TextProps;
};

export const CarrierLogoNext = ({
  plan,
  style,
  fw = 400,
  textProps,
  ...props
}: CarrierLogoNextProps) => {
  const [hasImageError, setHasImageError] = useState(false);

  const hasDimensions = !!props.width || !!props.height;
  const src = hasImageError
    ? plan.logoUrl
    : getCarrierLogoUrl(plan.carrierName);

  if (!src) {
    return (
      <Text fw={fw} style={{ whiteSpace: 'break-spaces' }} {...textProps}>
        {plan.carrierName}
      </Text>
    );
  }

  return (
    <Image
      src={src}
      alt={plan?.carrierName || 'carrier'}
      fill={!hasDimensions}
      style={{
        objectFit: 'contain',
        ...style,
      }}
      onError={() => {
        setHasImageError(true);
      }}
      {...props}
    />
  );
};
